<template>
  <LoadingBlock :loading="loading">
    <form @submit.prevent="submit">
      <div
          class="dropzone mb-4"
          :class="{ 'dropzone-active': isDragging, 'dropzone-has-file': selectedFile }"
          @dragover.prevent="isDragging = true"
          @dragleave.prevent="isDragging = false"
          @drop.prevent="onDrop"
          @click="$refs.fileInput.click()"
      >
        <input ref="fileInput" type="file" class="d-none" accept=".pdf,.jpg,.jpeg,.png"
               @change="onFileChange">
        <div v-if="!selectedFile">
          <span class="ti ti-upload ti-lg d-block mb-2"></span>
          <p class="mb-1">Перетащите файл сюда или нажмите для выбора</p>
          <small class="text-muted">PDF, JPEG, PNG</small>
        </div>
        <div v-else>
          <span class="ti ti-file ti-lg d-block mb-2"></span>
          <p class="mb-0">{{ selectedFile.name }}</p>
        </div>
      </div>

      <p v-if="loading" class="text-center text-muted">Обработка документа…</p>

      <div class="text-center mt-4">
        <button type="submit" class="btn btn-primary" :disabled="!selectedFile || loading">
          Создать сертификат
        </button>
      </div>
    </form>
  </LoadingBlock>
</template>

<script>
import LoadingBlock from "@/components/page/LoadingBlock.vue";
import {Message, Messages} from "@/data/messages";
import {createFromDocument} from "@/api/certificate";
import {user} from "@/data/user";
import {isAllowedCertificateFile, parseCertificateError} from "@/data/certificate";

export default {
  name: "CertificateFromDocumentForm",
  components: {LoadingBlock},
  data() {
    return {
      loading: false,
      isDragging: false,
      selectedFile: null,
    }
  },
  methods: {
    reset() {
      this.selectedFile = null
      this.isDragging = false
      this.loading = false
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = ''
      }
    },
    setFile(file) {
      if (!isAllowedCertificateFile(file)) {
        const message = new Message()
        message.type = 'failure'
        message.text = 'Недопустимый тип файла. Допустимы PDF, JPEG, PNG'
        Messages.list.push(message)
        return
      }
      this.selectedFile = file
    },
    onFileChange(event) {
      const file = event.target.files?.[0]
      if (file) {
        this.setFile(file)
      }
    },
    onDrop(event) {
      this.isDragging = false
      const file = event.dataTransfer.files?.[0]
      if (file) {
        this.setFile(file)
      }
    },
    async submit() {
      if (!this.selectedFile) {
        return
      }
      this.loading = true
      const message = new Message()
      try {
        const company_id = await user.getActiveCompany()
        const result = await createFromDocument(company_id, this.selectedFile)
        if (result.status === 200 || result.status === 201) {
          message.type = 'success'
          message.autoremove = 10
          message.text = 'Сертификат успешно создан'
          Messages.list.push(message)
          this.$emit('success', result.data)
        } else {
          message.type = 'failure'
          message.text = 'Не удалось создать сертификат'
          Messages.list.push(message)
        }
      } catch (e) {
        message.type = 'failure'
        message.text = parseCertificateError(e)
        Messages.list.push(message)
      }
      this.loading = false
    },
  },
}
</script>

<style scoped>
.dropzone {
  border: 2px dashed #d9dee3;
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;
}

.dropzone:hover,
.dropzone-active {
  border-color: #696cff;
  background-color: #f8f8ff;
}

.dropzone-has-file {
  border-style: solid;
}
</style>
